export default (node) => {
  /**
   * Data + elements
   */
  const locale = node.dataset.locale;
  /**
   * Functions
   */

  const handleize = (str) => {
    // Normalize string to remove accents
    str = str.normalize('NFD').replace(/[\u0300-\u036f]/g, '');

    // Remove special characters and spaces, replace with hyphens
    str = str.replace(/[^\w]+|\s+/g, '-');

    // Replace multiple hyphens with a single hyphen
    str = str.replace(/\-\-+/g, '-');

    // Remove leading and trailing hyphens
    str = str.replace(/(^-+|-+$)/g, '');

    // Lowercase the entire string
    return str.toLowerCase();
  };

  const loadColorSwatches = async () => {
    let response = null;
    let parsedResponse = null;
    let parser = null;
    let colorSwatchData = null;
    let infoColor = null;
    let infoColorData = null;
    let infoColorDataParsed = null;
    let nextPage = null;
    let count = 1;
    let pageToFetch = '/?sections=get-color-swatches';
    let colorSwatches = '';

    // get color swatch locale data from session storage
    let colorSwatchesLocaleData = sessionStorage.getItem('colorSwatchesLocaleData');
    let loadColorFromSession = false
    if (colorSwatchesLocaleData && colorSwatchesLocaleData !== null && colorSwatchesLocaleData.locale === locale) {
      loadColorFromSession = true;
    } else {
      sessionStorage.setItem('colorSwatchesLocaleData', locale);
    }

    // check if the color swatches are already in session storage
    let colorSwatchesFullData = [];

    // get the color swatches full data from session storage
    colorSwatchesFullData = JSON.parse(sessionStorage.getItem('colorSwatchesFullData'));
    if (colorSwatchesFullData && colorSwatchesFullData !== null && loadColorFromSession) {
      // add the color swatches to the document
      colorSwatchesFullData.forEach((color) => {

        document.documentElement.style.setProperty(
          `--color-${handleize(color.name)}`,
          color.color === 'Brown' || color.color === 'Brun'
            ? '#504034'
            : color.color
        );
        document.documentElement.style.setProperty(
          `--image-${handleize(color.name)}`,
          `url(${color.image})`
        );
      });
    } else {
      colorSwatchesFullData = [];
      do {
        try {
          if (count > 1) {
            pageToFetch = pageToFetch + `&page=${count}`;
          }
          response = await fetch(`${locale == 'fr' ? '/fr' : ''}${pageToFetch}`, {
            method: 'GET',
            headers: {
              'Content-Type': 'application/json',
            },
          });

          if (!response.ok) {
            throw new Error('Network response was not ok');
          }

          parsedResponse = await response.json();

          if (parsedResponse) {
            let { 'get-color-swatches': getColorSwatches } = parsedResponse;
            if (getColorSwatches) {
              parser = new DOMParser();
              colorSwatchData = parser.parseFromString(
                getColorSwatches,
                'text/html'
              );

              // add color swatches to the document
              infoColor = colorSwatchData.querySelector('[data-info-color]');
              if (infoColor) {
                infoColorData = infoColor.dataset.infoColor;
                if (infoColorData) {
                  infoColorDataParsed = JSON.parse(infoColorData);

                  // save in a variable for session storage
                  infoColorDataParsed.forEach((color) => {
                    const resolvedColor =
                      color.color === 'Brown' || color.color === 'Brun'
                        ? '#504034'
                      : color.color === 'Charcoal' || color.color === 'Charbon'
                        ? '#4e4b48'
                      : color.color === 'Gray' || color.color === 'Gris'
                        ? '#808080'
                      : color.color === 'White' || color.color === 'Blanc'
                        ? '#ffffff'
                      : color.color === 'Black' || color.color === 'Noir'
                        ? '#000000'
                      : color.color === 'Tan' || color.color === 'Beige'
                        ? '#ad9a84'
                      : color.color === 'Natural' || color.color === 'Naturel'
                        ? '#e8d3b5'
                      : color.color;

                      document.documentElement.style.setProperty(
                        `--color-${handleize(color.name)}`,
                        resolvedColor
                      );

                      document.documentElement.style.setProperty(
                        `--image-${handleize(color.name)}`,
                        `url(${color.image})`
                      );

                      colorSwatches += `--color-${handleize(color.name)}: ${resolvedColor}; `;
                      colorSwatches += `--image-${handleize(color.name)}: url(${color.image}); `;

                      colorSwatchesFullData.push(color);
                  });
                }
              }

              // update next page
              nextPage = colorSwatchData.querySelector('[data-page-next]');
              if (nextPage) {
                count++;
                pageToFetch =
                  nextPage.dataset.pageNext + '&sections=get-color-swatches';
              } else {
                pageToFetch = null;
              }
            }
          } else {
            pageToFetch = null;
          }
        } catch (error) {
          console.error('Error:', error);
          pageToFetch = null;
        }
      } while (pageToFetch !== null);

      // save in session storage
      sessionStorage.setItem('colorSwatchesFullData', JSON.stringify(colorSwatchesFullData));
    }

  };

  /**
   * Init
   */
  const init = () => {
    loadColorSwatches();
  };

  init();
};
